import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Card } from '../../../../components/shared/Card';

interface DisplayOptionsSectionProps {
  showHandle: boolean;
  onShowHandleChange: (v: boolean) => void;
  showBreweryName: boolean;
  onShowBreweryNameChange: (v: boolean) => void;
  showBeerStyle: boolean;
  onShowBeerStyleChange: (v: boolean) => void;
  showLocation: boolean;
  onShowLocationChange: (v: boolean) => void;
  showDescription: boolean;
  onShowDescriptionChange: (v: boolean) => void;
  showServings: boolean;
  onShowServingsChange: (v: boolean) => void;
  showServingSize: boolean;
  onShowServingSizeChange: (v: boolean) => void;
  showServingCurrency: boolean;
  onShowServingCurrencyChange: (v: boolean) => void;
  showDate: boolean;
  onShowDateChange: (v: boolean) => void;
  showLogo: boolean;
  onShowLogoChange: (v: boolean) => void;
  isCustomMenu: boolean;
}

export const DisplayOptionsSection: React.FC<DisplayOptionsSectionProps> = ({
  showHandle,
  onShowHandleChange,
  showBreweryName,
  onShowBreweryNameChange,
  showBeerStyle,
  onShowBeerStyleChange,
  showLocation,
  onShowLocationChange,
  showDescription,
  onShowDescriptionChange,
  showServings,
  onShowServingsChange,
  showServingSize,
  onShowServingSizeChange,
  showServingCurrency,
  onShowServingCurrencyChange,
  showDate,
  onShowDateChange,
  showLogo,
  onShowLogoChange,
  isCustomMenu
}) => {
  const { t } = useTranslation();

  return (
    <Card className="border border-gray-200 rounded-lg p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-1">{t('PrintDialog.Options')}</h2>
      <p className="text-sm text-gray-500 mb-4">{t('PrintDialog.DisplayOptionsSectionHelper')}</p>

      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">{t('PrintDialog.TapDetailsGroup')}</h3>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <FormControlLabel
              label={t('PrintDialog.ShowTapNumber')}
              control={<Checkbox checked={showHandle} onChange={(e) => onShowHandleChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PageEditForm.ShowBreweryName')}
              control={<Checkbox checked={showBreweryName} onChange={(e) => onShowBreweryNameChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PrintDialog.ShowBeerStyle')}
              control={<Checkbox checked={showBeerStyle} onChange={(e) => onShowBeerStyleChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PrintDialog.ShowLocation')}
              control={<Checkbox checked={showLocation} onChange={(e) => onShowLocationChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PrintDialog.ShowDescription')}
              control={<Checkbox checked={showDescription} onChange={(e) => onShowDescriptionChange(e.target.checked)} color="primary" />}
            />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">{t('PrintDialog.ServingsGroup')}</h3>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <FormControlLabel
              label={t('PrintDialog.ShowServings')}
              control={<Checkbox checked={showServings} onChange={(e) => onShowServingsChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PrintDialog.ShowServingSize')}
              control={<Checkbox checked={showServingSize} onChange={(e) => onShowServingSizeChange(e.target.checked)} color="primary" />}
            />
            <FormControlLabel
              label={t('PrintDialog.ShowServingCurrency')}
              control={
                <Checkbox checked={showServingCurrency} onChange={(e) => onShowServingCurrencyChange(e.target.checked)} color="primary" />
              }
            />
          </div>
        </div>

        {!isCustomMenu && (
          <div>
            <h3 className="text-sm font-medium text-gray-600 mb-2">{t('PrintDialog.PageGroup')}</h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
              <FormControlLabel
                label={t('PrintDialog.ShowDate')}
                control={<Checkbox checked={showDate} onChange={(e) => onShowDateChange(e.target.checked)} color="primary" />}
              />
              <FormControlLabel
                label={t('PageEditForm.ShowLogo')}
                control={<Checkbox checked={showLogo} onChange={(e) => onShowLogoChange(e.target.checked)} color="primary" />}
              />
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};
